export const translations = {
    en: {
        brand_logo: "erioon",
        main_title: "Scale beyond limits",
        main_description: "Built for massive data operations and intelligent cloud orchestration, Erioon brings performance and simplicity together.",
        second_description: "From data to deployment, Erioon OS handles it all - lightning-fast storage, compute power, and vector intelligence managed by a purpose-built AI.",
        second_main_title: "Erioon",
        start_now: "START NOW",
        login: "Login",
        edit: "Edit",
        delete: "Delete",
        suspend: "Suspend",
        activate: "Activate",
        yes: "Yes",
        no: "No",
        next: "Next",
        previous: "Previous",
        create: "Create",
        search: "Search for anything",
        save: "Save",
        cancel: "Cancel",
        active: "Active",
        suspended: "Suspended",
        deleted: "Deleted",
        copy_clipboard: "Copy to clipboard",
        copy: "Copy",
        err_page: "An error occurred while loading the resource. Please try again in a few minutes.",
        err_save_general: "An error occurred while saving. Please try again in a few minutes.",
        err_delete_general: "An error occurred while deleting. Please try again in a few minutes.",
        err_modify_general: "An error occurred while modifying. Please try again in a few minutes.",
        error: "Something went wrong...",
        apologies: 'We sincerely apologize for the inconvenience. Learn more about potential error causes ',
        problem_persists_mex: "If the problem persists, please open a ticket at",
        erioon_support: "Erioon Support",
        here_link: "here",
        docu_link: "documentation",
        reload_page: "Reload this page",
        now: "now",
        loading: "Loading...",
        
        from_oldest: "Oldest",
        from_newest: "Newest",

        register_form: {
            name: "Name",
            surname: "Surname",
            phone: "Phone",
            repeat_password: "Repeat password",
            button_register: "Sign Up",
            already_registered: "Already registered?",
            go_login: "Login",
            email_format: "The email format is incorrect...",
            password_err: "Password must be at least 10 characters long and contain uppercase letters, lowercase letters, special characters, and numbers..",
            password_match: "Passowrds don't match...",
            red_fields: "Check the required fields...",
            email_already_present: "Email already present...",
            errors_back: "An error was detected...retry",
            problem_back: "There is a problem with the access...rety in a few minutes",
            terms_conditions_desc: "I have read and accept the",
            t_c: "Terms and conditions",
            privacy_policy_desc: "I have read and accept the",
            p_p: "Privacy Policy",
            button_login: "Login",
            dont_have_account: "Don't have an account?",
            go_register: "Register",
            invalid_email_pass: "invalid email or password...retry",

            welcome_to: "Welcome to",
            description_one: "Built for massive data operations and intelligent cloud orchestration, Erioon brings performance and simplicity together with lightning-fast storage, compute power, and vector intelligence managed by a purpose-built AI.",

            welcome_back: "Welcome back!",
            update_mex: "The Erioon Python SDK has arrived — install it today and integrate effortlessly."

        },
       

        sidebar: {
            home: "Home",
            projects: "Projects",
            alerts: "Alerts",
            settings: "Settings",
            billing: "Billing",
            support: "Support",
            profile: "Profile",
            logout: "Logout",

            dashboard: "Dashboard",
            clusters: "Clusters",
            database: "Database",
            access: "Access",
            api: "API Keys",
            logs: "Logs",
            chat: "Erioon AI",
            new_chat: "New chat",
            cloud_storage: "Cloud storage",
            deleted_files: "Deleted files",
            admin_console: "Admin console"
        },
       
        popup: {
            success: "Saved successfully",
            error: "An error occurred"
        },

        profile: {
            profile_title: "Profile",
            access: "Access",
            main_credentials_subtitle: "The main credentials to access your environment",
            pb_information: "Personal & Business information",
            pb_subtitle: "All the information regarding your persona and your business",
            uid_title: "Your user ID",
            uid_subtitle: "Personal user ID code",
            activity_log: "Activity log",
            activity_log_subtitle: "Your recent activity log",
            no_activity: "No recent activity found",
            update_btn: "Update",
        },

        settings: {
            settings_title: "Settings"
        },

        delete_modal: {
            title: "Do you want to delete this resource?",
            del_warning: "This action CANNOT be undone. It will permanently delete the resource and all associated data.",
            confirm_del_mex: "To confirm, please enter the following: "          
        },

        projects: {
            no_data_found: "No projects found...",
            new_data_title: "Create a project container",
            new_data_subtitle: "Each container acts as a hub for different ideas, helping you centralize storage and scale effectively.",

            title: "Projects",
            subtitle: "Explore and manage all your projects.",

            
            new_project: {
                title: "Create a new project",
                subtitle: "Fill in all the fields and save your project.",
                name: "Project name",
                placeholder_name: "My Idea",
                description: "Project description",
                placeholder_desc: "A brief summary of your project...",
                err_name: "Please provide a name for the project",
                err_desc: "Please provide a description for the project",
            },

            update_project: {
                title: "Modify project details",
            }
        },

        apis: {
            title: "Generate API key",
            warning: "This API secret key grants access to your personal space using Erioon functions. For more details, refer to the",
            keep_secret_mex: "Keep it secure and do not share it with others.",
            name: "API Key Name",

            main_title: "API Keys",
            main_subtitle: "API keys allow access to the resources within your Erioon project."
        },

        access: {
            title: "Create a new access user",
            subtitle:"Each access has permissions that define the actions a user can perform within the resources.",

            main_title: "Access",
            main_subtitle: "Manage and monitor project access and permissions.",
            new_access: {
                title: "Create new access user",
                update_title: "Update access user",
                subtitle: "Fill in all fields and save the user access.",
                name: "Name",
                surname: "Surname",
                email: "Email",
                password: "Password",
                generate_password: "Generate secure password",
                access_type: "Choose the access type for the resources.",
                read_write: "Read and write to any database of this project",
                read_only: "Only read to any database of this project",
                read_write_short: "Read/Write",
                read_only_short: "Read only",
                full_access: "Allow full access control to any cluster of the project",
                full_access_short: "Full access",
                view_access_short: "View access",
                view_access: "Allow only view to any cluster of the project",
                month_free: "Get one free month for yearly subscriptions!",
                resume: "Resume for new access user",
                select_project: "Select a project",
                confirm_invitation: "Confirm & send invitation",

                err_name: "Please provide a name for the access user",
                err_surname: "Please provide a surname for the access user",
                err_email: "Please provide an email for the access user",
                err_email_format: "The provided email is incorrect: check the format!",
                err_password: "Please provide a password for the access user", 
            },
            table: {
                no_data: "No access users found...",
                _id: "Record ID",	
                access_email: "Email",	
                cluster: "Compute",	
                database: "Databases",	
                project_id: "Project",	
                timestamp: "Timestamp",	
                access_user: "User",

                viewAccess: "View access",
                fullAccess: "Full access",
                read: "Only read",
                write: "Read/Write",

            }
        },

        deployments: {
            table: {
                no_data: "No deployments found...",
                _id: "Record ID",	
                buildpack: "Buildpack",	
                deployment_name: "Deployment name",	
                deployment_type: "Deployment type",	
                schedule: "Schedule",	
                status: "Status",	
                timestamp: "Timestamp",
            }
        },

        cloud: {
            title: "Cloud Storage",
            consumed: "consumed",
            upload_file: "Upload file",
            deleted_files: "Deleted files",
            all_files: "All files",
            move_to_deleted: "Move to deleted",
            share: "Share",
            restore: "Restore",
            delete_permanently: "Delete permanently",
            
            choose_file_title: "Choose which files to upload in your cloud space",
            choose_file_btn: "Choose file",
            selected_files: "Selected files",
            upload: "Upload",

            no_files_found: "No files or documents...",

            warning_mex_share: "This link grants access to a shared space where the people you share it with can view and download specific files and documents. Please avoid sharing sensitive information.",

            restore_file: "Do you want to restore the selected files?",
            restore_warning: "This action will restore the selected files",
            
            delete_file: "Do you want to delete the selected files?",
            delete_warning: "This action CANNOT be undone. This will PERMANENTLY DELETE the selected files.",
            delete_temp_warning: 'This action can be undone. This will move selected files in the "Deleted files" section.',
        
            cloud_table: {
                id: "ID",
                filename: "Filename",
                size : "Size MB",
                preview: "Preview",
                created: "Created",
                folder_path: "Folder path",
                status: "Status",
            },
            modal: {

            }
        },

        shared_space: {
            sender_text: "shared something with you!",
            all_files: "All files",
            share: "Share item",
            item_copied: "URL copied",
            no_file_mex: "has removed all the items from this shared space...",
            item: "Item",
            items: "Items",
            no_items_found: "No items found...",
            shared_title: "What is a shared space?",
            shared_desc: "A shared space is a secure, encrypted Erioon environment that allows users to share data, files, and documents beyond their organization."
        },
    }
}